// extracted by mini-css-extract-plugin
module.exports = {"center":"_2nXEu","justify":"_2ZA-G","left":"_2Ea3z","right":"_34j9e"};